import { module } from 'angular';
import component from './base-block.component';

export default module('app')
	.component('baseBlock', component);
